<template>
    <card class="spaced typo">

        <h2 class="text-white">
            {{ $t('xapi.management.delete-logs.title') }}
        </h2>

        <p>
            {{ $t('xapi.management.delete-logs.description') }}
        </p>

        <context-filters></context-filters>

        <base-button type="primary mt-3" :loading="deleting" @click="deleteLogs">
            {{ $t('xapi.management.delete-logs.button') }}
        </base-button>

        <div class="text-danger pt-2" v-if="error">
            {{ $t('xapi.management.delete-logs.error') }}
        </div>

        <portal to="modals">
            <modal-confirm v-model="modals.confirmDeleteLogs">
                <p>{{ $t('xapi.management.delete-logs.confirm') }}</p>
            </modal-confirm>
        </portal>

    </card>
</template>

<script>
    import ModalsController from '@trax/classes/ModalsController'

    export default {
    
        data() {
            return {
                filters: this.$xapi.filters.context,
                modals: new ModalsController('confirmDeleteLogs'),
                deleting: false,
                error: false
            }
        },

        created() {
            this.modals.watch(this, 'modals')
        },

        methods: {

            deleteLogs() {
                this.error = false
                this.modals.open('confirmDeleteLogs').then(resp => {
                    if (resp.confirmed) {
                        this.deleting = true
                        axios.delete(
                            '/trax/api/front/xapi/ext/logs',
                            { params: this.filters.get() }
                        )
                        .then(response => {
                            this.deleting = false
                        })
                        .catch(error => {
                            this.deleting = false
                            this.error = true
                            this.$auth.handleErrorVm(error, this)
                        });
                    }
                })
            }
        }
    }
</script>
